import script from "./TemplateList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateList.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateList.vue?vue&type=style&index=0&id=7e779cb8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e779cb8"]])

export default __exports__